<template>
  <hr />
</template>

<style lang="postcss" scoped>
hr {
  @apply border-gray-100 my-8 border-t;
}

hr + * {
  @apply mt-0;
}
</style>
